import { AuditEventRow } from "../components/admin/AuditEventRow";
import { Skeleton } from "../components/dashboard/Skeleton";
import { useAuditEvents } from "../hooks/useAuditEvents";
import styles from "./AuditTrail.module.css";
import { AdminPageIntro } from "../components/admin/AdminPageIntro";

export const AuditTrail = (): JSX.Element => {
  const { status, events, error } = useAuditEvents("admin");

  return (
    <div className={styles.page}>
      <AdminPageIntro title="Audit">
        Every audited action across every tenant, newest first.
      </AdminPageIntro>

      {status === "loading" && (
        <ul className={styles.list} aria-hidden>
          {Array.from({ length: 8 }, (_, i) => (
            <li key={i} className={styles.row}>
              <div className={styles.time}>
                <Skeleton width="64px" height="0.85rem" />
                <Skeleton width="110px" height="0.7rem" />
              </div>
              <Skeleton width="84px" height="1.4rem" radius="999px" />
              <div className={styles.body}>
                <Skeleton width="40%" height="0.95rem" />
                <Skeleton width="60%" height="0.75rem" />
              </div>
            </li>
          ))}
        </ul>
      )}

      {status === "error" && (
        <div className={styles.errorPanel}>
          {error ?? "Couldn't load your audit events."}
        </div>
      )}

      {status === "ready" && events.length === 0 && (
        <div className={styles.empty}>
          <div className={styles.emptyMark} aria-hidden>🦞</div>
          <h3 className={styles.emptyTitle}>No activity yet</h3>
          <p className={styles.emptyBody}>
            Once tenants launch or admins act, events show up here.
          </p>
        </div>
      )}

      {status === "ready" && events.length > 0 && (
        <ul className={styles.list}>
          {events.map((event) => (
            <AuditEventRow key={`${event.tenantId}-${event.eventTime}`} event={event} />
          ))}
        </ul>
      )}
    </div>
  );
};
